import { apiGet } from './client';
import type { WebsiteStatus } from '../types/api';

export interface SiteListItem {
  id: string;
  customer_id: string;
  business_name: string;
  status: WebsiteStatus;
  generator_version: string | null;
  cloudflare_url: string | null;
  custom_domain: string | null;
  /** Whether that custom domain is actually serving. See SitesPage domain cell. */
  domain_verification_status:
    | 'pending'
    | 'verifying'
    | 'verified'
    | 'failed'
    | 'connected'
    | null;
  created_at: string;
  launched_at: string | null;
  last_updated: string;
  customer_email: string;
  customer_name: string | null;
  subscription_plan: string | null;
  subscription_status: string | null;
}

export interface SitesListParams {
  status?: string;
  search?: string;
  page?: number;
  limit?: number;
  sort?: string;
  order?: 'asc' | 'desc';
}

export interface SitesListResponse {
  success: boolean;
  sites: SiteListItem[];
  total: number;
  page: number;
  limit: number;
  statusCounts: Record<string, number>;
}

export async function getSites(
  params: SitesListParams = {}
): Promise<SitesListResponse> {
  const searchParams = new URLSearchParams();
  if (params.status) searchParams.set('status', params.status);
  if (params.search) searchParams.set('search', params.search);
  if (params.page) searchParams.set('page', String(params.page));
  if (params.limit) searchParams.set('limit', String(params.limit));
  if (params.sort) searchParams.set('sort', params.sort);
  if (params.order) searchParams.set('order', params.order);

  const query = searchParams.toString();
  return apiGet<SitesListResponse>(
    `/api/admin/sites${query ? `?${query}` : ''}`
  );
}
